import api from "@/http/http-sritrang-family";

const getId = async (data) => {
  return await api.post("/sylogin/loginoauthload/", data);
};

export default { getId };
